<template>
  <div class="menu-wrapper">
    <template v-for="(item,index) in routes" v-if=' !item.hidden && item.children '>
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :key="item.children[0].name" :to="item.path+'/'+item.children[0].path">
        <el-menu-item ref="menuItem" :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <img class="menuicon" v-if="item.children[0].meta&&item.children[0].meta.icon" :src="bingIcon(item.children[0].meta.icon)" alt="">
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{ item.children[0].meta.title }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :key="item.name" :index="item.path||item.name">
        <template slot="title">
          <!-- <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon" /> -->
          <img class="menuicon" v-if="item.meta&&item.meta.icon" :src="bingIcon(item.meta.icon)" alt="">
          <span v-if="item.meta&&item.meta.title" slot="title">{{ item.meta.title }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <!-- <sidebar-item v-if="child.children&&child.children.length>0" :key="child.path" :is-nest="true" class="nest-menu" :routes="[child]" /> -->
          <!-- <a :key="child.name" @click="shishiClick('#'+item.path+'/'+child.path)">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon" />
              <span v-if="child.meta&&child.meta.title" slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </a> -->

          <SidebarItem v-if="isJudgeShowFun(child)" :routes="item.children"></SidebarItem>
          <a v-else :key="child.name" @click="shishiClick(child.path)">
            <el-menu-item :index="child.path">
              <img class="menuicon" v-if="child.meta&&child.meta.icon" :src="bingIcon(child.meta.icon)" alt="">
              <span class="menuspan" v-if="child.meta&&child.meta.title" slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </a>

        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      default() {
        return []
      },
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    //console.log(this.$refs.menuItem.ariaHasPopup, "menuItem")
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    bingIcon (icon) {
      try {
        return require(`../../../assets/${icon}`)
      } catch (err) {
        console.error('资源加载失败:', err)
        return '' // 返回空值或默认占位图路径
      }
    },
    shishiClick(url) {
      console.log('url', url, this.routes)
      // this.$loading()
      // const host = window.location.href
      // const arr = host.split("#");

      // console.log(arr, 344543);
      // window.location.href = arr[0] + url
      // window.location.href = arr[0] + url
      this.$router.push({ path: url })
      // window.location.href = url
      // window.location.reload()
    },
    isJudgeShowFun (item) {
      if (item.children && item.children.length > 0) {
        return true
      }
      return false
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.menuicon {
  width: 20px;
  height: 20px;
  margin-right: 22px;
  margin-left: 14px;
}
.menuspan {
  margin-left: 58px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/SidebarItem.vue